import { Notificacoes } from '@/types/core'
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import { timeout } from '@/utils/common'
import { EmailMensagem, DataTablePagination, EmailMensagemQuery } from '@/types/_'


@Module({ namespaced: true, name: 'BackofficeNotificacoesStore' })
export default class BackofficeNotificacoesStore extends VuexModule {
  private notificacoes: Notificacoes.INotificacoes = new Notificacoes.Notificacoes()
  private emailDefault: EmailMensagem = {
    id: '',
    emailEnviadoId: null,
    assunto: '',
    mensagem: '',
    emailOrigem: '',
    dataRecebido: '',
    mensagemResolvida: false,
    tipoEmailDisplay: null,
    solicitacaoId: null,
    numeroAgendamento: null,
    emailRecebidoAnexo: [],
    hospitalId: '',
    resolvidoPor: '',
    resolvidoPorUsuarioNome: '',
    resolvidoQuando: '',
  }

  private mensagensDefault: EmailMensagem[] = []
  private paginationDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 10,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [25, 50, 100, 200],
  }

  public mensagens: EmailMensagem[] = [...this.mensagensDefault]
  public email: EmailMensagem = { ...this.emailDefault }
  public emailModal: any = {
    listagem: false,
    resolucao: false,
  }

  public tableHeaders: any[] = [
    { text: 'Assunto', class: 'table-headers-email', align: 'left', value: 'assunto', sortable: false },
    { text: 'Enviado por', class: 'table-headers-email', align: 'left', value: 'emailOrigem', sortable: false },
    { text: 'Data e hora', class: 'table-headers-email', align: 'left', value: 'dataRecebido', sortable: false },
    { text: 'Tipo', class: 'table-headers-email', align: 'left', value: 'tipoEmailDisplay', sortable: false },
    { text: 'Nº da reserva', class: 'table-headers-email', align: 'left', value: 'numeroAgendamento', sortable: false },
    { text: 'Status', class: 'table-headers-email', align: 'left', value: 'mensagemResolvida', sortable: false },
  ]

  public search: string = ''
  public pagina: number = 1
  public rowsPerPage: number = 10
  public totalItems: number = 0
  public listSize: number[] = [25, 50, 100, 200]
  public loading: boolean = false
  public pagination: DataTablePagination = { ...this.paginationDefault }

  public disabledBtns: boolean = false
  public loadingBtn: boolean = false
  public atualizada: boolean = false
  public naoAtualizada: boolean = false

  @Action
  async getMensagens(param: EmailMensagemQuery) {
    try {
      const request = await this.notificacoes.getEmailsRecebidos(param)
      if (request.success) {
        const { commit } = this.context
        commit('setMensagens', request.data.emailRecebido)
        commit('setPagination', {
          descending: false,
          page: param.pagina,
          rowsPerPage: param.qtdPorPagina,
          sortBy: null,
          totalItems: request.data.total,
          rowsPerPageItems: [25, 50, 100, 200],
        })
        return this.mensagens
      }
      return request.message
    } catch (error) {
      // @ts-ignore
      return error.message
    }
  }

  @Action
  async updateEmail(id: string) {
    this.context.commit('setLoadingBtn', true)
    this.context.commit('setDisabledBtns', true)

    const request = await this.notificacoes.backofficeResolveEmail(id)

    if (request.success) {
      const email = this.mensagens.find(e => e.id === id)
      await this.context.dispatch('updateMensagens', email)
      this.context.commit('setAtualizada', true)
      this.context.commit('setLoadingBtn', false)
    } else {
      this.context.commit('setNaoAtualizada', true)
      this.context.commit('setLoadingBtn', false)
    }

    await timeout(2000)
    this.context.commit('setDisabledBtns', false)
    this.context.dispatch('resetEmail')
  }

  @Action
  async updateMensagens(value: any) {
    const email = { ...value }
    const mensagens = [...this.mensagens]
    const index = mensagens.findIndex(e => e.id === email.id)
    mensagens.push(mensagens.splice(index, 1)[0])
    // @ts-ignore
    mensagens[mensagens.length - 1].mensagemResolvida = true
    await timeout(0)
    this.context.commit('setMensagens', mensagens)
  }

  @Mutation
  setPagination(val: DataTablePagination) {
    this.pagination = val
  }

  @Mutation
  setListagem(value: boolean) {
    this.emailModal.listagem = value
  }

  @Mutation
  setResolucao(value: boolean) {
    this.emailModal.resolucao = value
  }

  @Mutation
  setMensagens(value: EmailMensagem[]) {
    this.mensagens = value
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setRowsPerPage(value: number) {
    this.rowsPerPage = value
  }

  @Mutation
  setTotalItems(value: number) {
    this.totalItems = value
  }

  @Mutation
  setLoading(value: boolean) {
    this.loading = value
  }

  @Mutation
  setEmail(value: any) {
    this.email = value
  }

  @Mutation
  setSearch(value: string) {
    this.search = value
  }

  @Mutation
  setDisabledBtns(value: boolean) {
    this.disabledBtns = value
  }

  @Mutation
  setLoadingBtn(value: boolean) {
    this.loadingBtn = value
  }

  @Mutation
  setAtualizada(value: boolean) {
    this.atualizada = value
  }

  @Mutation
  setNaoAtualizada(value: boolean) {
    this.naoAtualizada = value
  }

  @Mutation
  clearMensagens() {
    this.mensagens = [...this.mensagensDefault]
  }

  @Mutation
  clearPagination() {
    this.pagination = { ...this.paginationDefault }
  }

  @Mutation
  clearEmail() {
    this.email = { ...this.emailDefault }
  }

  @Mutation
  clearSearch() {
    this.search = ''
  }

  @Action
  resetEmail() {
    this.context.commit('setAtualizada', false)
    this.context.commit('setNaoAtualizada', false)
    this.context.commit('setDisabledBtns', false)
    this.context.commit('setLoadingBtn', false)
    this.context.commit('setResolucao', false)
  }
}
